export default __webpack_public_path__ + "fd320b2e4b7f8f6655b385b5df38dbc2.png";